import {
  Component,
  inject,
  model,
  OnDestroy,
  OnInit,
  TemplateRef,
  viewChild,
} from '@angular/core';
import {
  NgbOffcanvasModule,
  NgbNavModule,
  NgbOffcanvas,
  NgbOffcanvasRef,
  NgbOffcanvasOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, merge, Subscription } from 'rxjs';

import { MEDIA_BREAKPOINTS } from '../../constants';
import { SearchComponent } from '../search/search.component';

import { PostMessageService, SearchService } from '../../services/app';

@Component({
  selector: 'app-search-drawer',
  templateUrl: './search-drawer.component.html',
  standalone: true,
  imports: [NgbOffcanvasModule, NgbNavModule, SearchComponent],
})
export class SearchDrawerComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];
  private _content = viewChild<TemplateRef<any>>('content');
  private _offCanvasService = inject(NgbOffcanvas);
  private _offCanvasRef?: NgbOffcanvasRef;
  private _searchService = inject(SearchService);
  private _postMessageService = inject(PostMessageService);

  ngOnInit(): void {
    this._subscriptions$.push(
      merge(
        this._searchService.search$,
        this._searchService.navigate$,
      ).subscribe(() => {
        this._offCanvasRef?.close();
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscriptions$.forEach((s) => s?.unsubscribe());
  }

  open() {
    let position: NgbOffcanvasOptions['position'] = 'end';
    const viewWidth = window.innerWidth;
    if (viewWidth < MEDIA_BREAKPOINTS.md) {
      position = 'bottom';
    }
    this._offCanvasRef = this._offCanvasService.open(this._content(), {
      position,
    });
    this._postMessageService.postMessageScrollIntoView();
  }
}
